// How long a login on the login origin keeps the Stytch SSO session alive.
//
// The dashboard, Grafana and the Buildbarn Browser sit behind oauth2-proxy, whose
// own session lapses with the access token (about an hour). Each lapse renews
// silently against this SSO session, so this is what bounds how often anyone has
// to sign in interactively.
//
// PREREQUISITE: this must not exceed each Stytch project's maximum session
// duration (Dashboard -> SDK configuration, set separately for Live and Test).
// Stytch rejects anything longer with invalid_session_duration and login fails
// for everyone -- raise the dashboard maximum BEFORE raising this value.
export const STYTCH_SESSION_DURATION_DAYS = 90;
export const STYTCH_SESSION_DURATION_MINUTES = STYTCH_SESSION_DURATION_DAYS * 24 * 60;
